export const financialRunwayFAQs = [
  {
    id: "calculate-financial-runway-career-pivot",
    q: "How do I calculate my financial runway when planning a career pivot or reskilling?",
    a: "To calculate your financial runway for a career pivot, divide your available financial resources by your estimated net monthly burn rate. The ReigniteSpirit Financial Runway Calculator helps estimate this using the financial details you enter.",
  },
  {
    id: "countries-supported-by-runway-calculator",
    q: "Does this financial runway calculator support expats and nationals across different countries?",
    a: "Yes. The calculator currently supports selected residency and regional configurations across the United States, United Kingdom, India, Pakistan and several GCC countries.",
  },
  {
    id: "labor-law-gratuity-and-severance",
    q: "How do gratuity and severance affect my career runway calculation?",
    a: "Eligible gratuity or severance can increase the financial resources available during a career transition. Any result produced by the calculator is an estimate based on the information entered and the regional logic currently implemented.",
  },
  {
    id: "outstanding-debt-versus-monthly-emi",
    q: "Should I include total outstanding debt or only monthly EMIs?",
    a: "Monthly EMIs should be included in recurring expenses. Total outstanding debt should also be reviewed separately as a longer-term financial obligation and risk.",
  },
  {
    id: "inflation-drag-in-runway-calculation",
    q: "Why is inflation included in my runway calculation?",
    a: "Inflation may reduce the purchasing power of savings over time. Including an inflation assumption can provide a more conservative runway estimate.",
  },
  {
    id: "months-before-resignation-or-job-loss",
    q: "How does the period before resignation or job loss affect the calculation?",
    a: "The period before transition can allow additional savings to accumulate. The calculator may include the estimated surplus or deficit generated during this period.",
  },
  {
    id: "bank-account-linking-requirement",
    q: "Do I need to connect my bank account?",
    a: "No. The calculator uses information that you manually enter and does not require access to your banking credentials.",
  },
  {
    id: "financial-advice-disclaimer",
    q: "Does this calculator provide financial advice?",
    a: "No. It is an informational and educational planning tool. It does not provide financial, investment, legal, accounting or tax advice.",
  },
];